@use '@design/design-tokens/typography/typography' as *;

.emptyStarredWrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 80px 8px;
}

.title {
  margin-top: 24px;
  margin-bottom: 12px;

  @include typography-v2-title-base;
}

.description {
  @include typography-v2-body-sm;

  color: var(--text-soft);
  text-align: center;
}
